import { DOCUMENT_TITLE } from 'constants/config';

const notificationMessage = 'New Assistance Request';

export const setNotificationsInterval = (interval = 1000) =>
  setInterval(() => {
    document.title !== notificationMessage ? (document.title = notificationMessage) : (document.title = DOCUMENT_TITLE);
  }, interval);
